<template>
<div class="dish-filters" :class="{ isVisible: toggleFilters, 'screen-lg': this.onTabletUp && isPrimaryRecipes }">
  <div class="filters-header">
    <h3 v-if="this.location === 'embed' || !isPrimaryRecipes"><BaseIcon class="filter-icon" name="filter" />{{ $t('lblFilter') }}</h3>
    <h4 v-if="this.location === 'embed' || !isPrimaryRecipes">Results: {{ dishes.length }}</h4>
    <h4 v-if="this.location === 'embed' || !isPrimaryRecipes" @click="setToggleFilters">{{ $t('lblClose') }}</h4>

    <div class="section-list form-field" v-if="this.onTabletUp && !toggleFilters">
      <baseInput
        inputType="search"
        :placeholder="$t('recipes.filters.searchPlaceholder')"
        @keyup="filterDishes($event.target.value)"
        @keyup.delete="$emit('retry-filter-dishes', $event.target.value.toLowerCase())"
      />
    </div>
  </div>
  <div class="filter-options-wrapper">
    <div class="option-favorites">
      <img class="option-img" :src="favoritesIcon" @click="filterFavorites" />
      <p>{{ $t('recipes.filters.favorite') }}</p>
    </div>
    <div class="filter-group" v-for="(group, name, i) in filterOpts.groups" :key="i">
      <h4 class="group-title">By {{ name }} </h4>
      <div class="option" v-for="(opt, i) in group.options" :key="i" @click="toggleCheck(group, opt)">
        <transition name="fade">
          <svg class="icon-circle" svg-inline="" key="unchecked" v-if="!isChecked(group, opt)" focusable="false" role="presentation" width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg"><circle cx="28" cy="31" r="12" fill="none" transform="translate(-15 -18)" stroke="#F7C11C" stroke-width="2"/></svg>
          <svg class="icon-circle" svg-inline="" key="checked" v-if="isChecked(group, opt)" focusable="false" role="presentation" width="30" height="26" viewBox="0 0 30 26" xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 1)" fill="none" fill-rule="evenodd"><circle stroke="#F7C11C" stroke-width="2" cx="12" cy="12" r="12"/><path d="M20 9l4-4" stroke="#FFF" stroke-width="7" fill="#D8D8D8" stroke-linecap="square"/><path stroke="#F7C11C" stroke-width="2.5" d="M6.884 10l6.094 5.339L25.196 3.737"/></g></svg>
        </transition>
        <img class="option-img" src="opt.imageUrl" v-if="opt.imageUrl" />
        <p>{{ opt.name }}</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { dishesComputed, dishesMethods, kitchenDrawerComputed, primaryNavComputed } from '@state/helpers';
import { breakpointsMixin } from 'breakpointsMixin';

export default {
  mixins: [breakpointsMixin],
  components: {},
  props: {
    onTabletUp: {
      type: Boolean,
    },
    location: {
      type: String,
      default: 'embed',
    },
  },
  data() {
    return {
      heartIcon: require('@assets/images/icon-heart.svg'),
      openHeartIcon: require('@assets/images/icon-heart-o.svg'),
      favoritesIcon: this.openHeartIcon,
      toggleFavorites: false,
    };
  },
  computed: {
    ...dishesComputed,
    ...kitchenDrawerComputed,
    ...primaryNavComputed,
    currentView() {
      return this.navContent[this.activeNavIndex];
    },
    currentPrimaryView() {
      return this.primaryNavContent[this.activePrimaryNavIndex];
    },
    isPrimaryRecipes() {
      return this.currentPrimaryView.component === 'Recipes';
    },
  },
  mounted() {
    this.favoritesIcon = this.openHeartIcon;
  },
  methods: {
    ...dishesMethods,
    isChecked(group, opt) {
      if (this.filterQueryString[group.requestParameterLabel]) {
        return this.filterQueryString[group.requestParameterLabel].find((value) => {
          return value === opt.requestParameterValue;
        });
      } else {
        return false;
      }
    },
    toggleCheck(group, opt) {
      if (!this.isChecked(group, opt)) {
        const clone = _.cloneDeep(this.filterQueryString);
        clone[group.requestParameterLabel].push(opt.requestParameterValue);
        this.setFilterQueryString(clone);
      } else {
        const clone = _.cloneDeep(this.filterQueryString);
        clone[group.requestParameterLabel] = clone[group.requestParameterLabel].filter((value) => value !== opt.requestParameterValue);
        this.setFilterQueryString(clone);
      }
      this.getDishes();
    },
    filterDishes(val) {
      if (val.length >= 2) {
        this.$emit('filter-dishes', val.toLowerCase());
      }
    },
    filterFavorites() {
      this.setIsFavoritesVisible();
      this.toggleFavorites = !this.toggleFavorites;

      if (this.toggleFavorites) {
        this.favoritesIcon = this.heartIcon;
      } else {
        this.favoritesIcon = this.openHeartIcon;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.dish-filters {
  background-color: $color-dish-filters-bg;
  height: 100%;
  overflow-x: auto;
  padding: 2rem;
  position: fixed;
  transform: translateX(100%);
  transition: transform $duration-animation-base ease-out;
  width: 100%;
  will-change: transform;
  z-index: 9999;

  &.isVisible {
    position: absolute;
    transform: translateX(0);
  }

  .filters-header {
    align-items: center;
    border-bottom: 1px solid $base-border-color;
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.8rem;

    h4:hover {
      cursor: pointer;
    }
  }

  .filter-options-wrapper {
    height: 100%;
    overflow: scroll;
    padding: 2.4rem 0 4rem;
  }

  .option-favorites {
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    margin-bottom: 1rem;
    padding: 0.6rem 0 0;

    img:hover {
      cursor: pointer;
    }

    p {
      margin-bottom: 0;
      margin-left: 0.6rem;
    }
  }

  .filter-icon {
    margin-right: 0.5rem;
  }

  .filter-group {
    margin-bottom: 3.2rem;
    position: relative;

    .group-title {
      font-size: 1.6rem;
      font-weight: bold;
      margin-bottom: 1.6rem;
    }

    .option {
      font-size: 1.5rem;
      margin: 0;
      position: relative;

      &:not(:last-child) {
        margin: 0 0 1.8rem 0;
      }

      .fade-enter-active {
        transition: opacity $duration-animation-base + 0.2;
      }
      .fade-leave-active {
        transition: opacity $duration-animation-base - 0.5;
      }
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }

      .icon-circle {
        position: absolute;
        top: -0.2rem;
      }

      svg {
        circle,
        g path:last-child {
          stroke: $color-checkbox-stroke;
        }
      }

      p {
        margin-left: 3.6rem;
        padding: 0.6rem 0 0;
      }

      .option-img {
        border-radius: $border-radius-circle;
        margin-right: 1rem;
        width: 3.5rem;
      }
    }
  }

  &.screen-lg {
    background-color: transparent;
    position: relative;
    transform: translateX(0);
    width: 30%;
    z-index: 0;

    .filters-header {
      border: 0;
      margin-bottom: 1rem;

      input {
        margin-bottom: 0;
      }
    }

    .filter-options-wrapper {
      height: 100vh;
      padding-bottom: 18rem;
      padding-top: 0;

      .filter-group {
        margin-bottom: 3rem;
      }

      .group-title {
        margin-bottom: 1rem;
      }

      .option {
        font-size: 1.4rem;

        &:not(:last-child) {
          margin-bottom: 1.5rem;
        }

        p {
          line-height: 1.2;
        }

        .icon-circle {
          top: 0;
        }
      }
    }

    .recipe-items-wrapper {
      height: 100vh;
      overflow-y: scroll;
      padding-bottom: 20rem;
    }
  }
}
</style>
